<template>
  <div v-if="broadcast" class="mt-5">
    <v-btn flat @click="onBack">
      <em class="fas fa-chevron-left mr-1" />
      {{ $t('Back') }}
    </v-btn>
    <v-container>
      <h3 class="headline">{{ $t('Broadcast Detail') }}</h3>
    </v-container>

    <template v-if="broadcast">
      <v-container>
        <div>{{ $t('Broadcast Name') }}</div>
        <div class="primary--text">{{ name }}</div>
      </v-container>
      <v-divider></v-divider>
      <v-container>
        <div>{{ $t('Message Type') }}</div>
        <div class="primary--text" v-if="sendtype == 'subscription'">{{ $t('Subscription') }}</div>
        <div class="primary--text" v-else-if="sendtype == 'promotion'">
          {{ $t('Promotional Message (within 24 hours)') }}
        </div>
        <div class="primary--text" v-else-if="sendtype == 'ACCOUNT_UPDATE'">
          {{ $t('Account Update') }}
        </div>
        <div class="primary--text" v-else-if="sendtype == 'CONFIRMED_EVENT_UPDATE'">
          {{ $t('Confirmed Event Update') }}
        </div>
        <div class="primary--text" v-else-if="sendtype == 'POST_PURCHASE_UPDATE'">
          {{ $t('Post-Purchase Update') }}
        </div>
        <div class="primary--text" v-else>
          {{ $t(sendtype) }}
        </div>
      </v-container>
      <v-divider></v-divider>
      <v-container>
        <div>{{ $t('Notification Setting') }}</div>
        <div class="primary--text" v-if="pushtype == 'REGULAR'">{{ $t('Regular Push') }}</div>
        <div class="primary--text" v-else-if="pushtype == 'SILENT_PUSH'">
          {{ $t('Silent Push') }}
        </div>
        <div class="primary--text" v-else-if="pushtype == 'NO_PUSH'">{{ $t('No Push') }}</div>
      </v-container>
      <v-divider></v-divider>
      <v-container>
        <div>{{ $t('Target') }}</div>
        <div>
          <template v-if="groupType == ''">
            <div class="primary--text mt-3">{{ $t('All') }}</div>
          </template>
          <template v-else-if="groupType == 'facebook'">
            <div class="primary--text mt-3">{{ $t('Facebook') }}</div>
          </template>
          <template v-else-if="groupType == 'line'">
            <div class="primary--text mt-3">{{ $t('Line') }}</div>
          </template>
          <template v-else-if="groupType == 'customize'">
            <div class="mt-3" style="border: 1px solid #eee; border-radius: 10px">
              <table>
                <tr>
                  <td>{{ $t('name') }}</td>
                  <td class="primary-color">{{ filter.fullname ? filter.fullname : '-' }}</td>
                </tr>
                <tr class="grey lighten-4">
                  <td>{{ $t('Channel') }}</td>
                  <td class="primary-color">
                    <span style="color: #3b5998" v-if="filter.app == 'facebook'">
                      <em class="fab fa-facebook-square" /> Facebook
                    </span>
                    <span style="color: #00c300" v-else-if="filter.app == 'line'">
                      <em class="fab fa-line" /> Line
                    </span>
                    <span v-else>{{ $t('All') }}</span>
                  </td>
                </tr>
                <tr>
                  <td>{{ $t('gender') }}</td>
                  <td class="primary-color">
                    <template v-if="filter.gender == 'male'">{{ $t('Male') }}</template>
                    <template v-else-if="filter.gender == 'female'">{{ $t('Female') }}</template>
                    <template v-else-if="filter.gender == 'all'">{{ $t('All') }}</template>
                  </td>
                </tr>
                <tr class="grey lighten-4">
                  <td>{{ $t('Locale') }}</td>
                  <td class="primary-color">
                    <template v-if="filter.locale && filter.locale.length > 0">
                      <span v-for="(locale, index) in filter.locale" :key="'locale_' + index">
                        <flag :iso="locale.icon" />
                        {{ locale.title }}
                        <template v-if="index != filter.locale.length - 1">,</template>
                      </span>
                    </template>
                    <template v-else>-</template>
                  </td>
                </tr>

                <tr>
                  <td>{{ $t('Conversation') }}</td>
                  <td class="primary-color">
                    <template v-if="filter.intent && filter.intent.length > 0">
                      <span v-for="(intent, index) in filter.intent" :key="'intent_' + index">
                        {{ intent }}
                        <template v-if="index != filter.intent.length - 1">,</template>
                      </span>
                    </template>
                    <template v-else>-</template>
                  </td>
                </tr>
                <tr class="grey lighten-4">
                  <td>{{ $t('Email') }}</td>
                  <td class="primary-color">{{ filter.email ? filter.email : '-' }}</td>
                </tr>
                <tr>
                  <td>{{ $t('phone no.') }}</td>
                  <td class="primary-color">{{ filter.phoneno ? filter.phoneno : '-' }}</td>
                </tr>

                <!-- <tr v-if="filter.messagesent.value != '' || filter.messagesent.value != null">
                <td>{{$t('Message Sent')}}</td>
                <td
                  class="primary-color"
                >{{filter.messagesent.symbol == 'g__' ? $t('Greater than') : (filter.messagesent.symbol == 'l__' ? $t('Less than') : $t('Not'))}} {{filter.messagesent.value}}</td>
              </tr>-->
                <tr
                  class="grey lighten-4"
                  v-if="filter.registerDate.start || filter.registerDate.end"
                >
                  <td>{{ $t('First Conversation at') }}</td>
                  <td class="primary-color">
                    <template v-if="filter.registerDate.start"
                      >{{ filter.registerDate.start | DateFormat('DD/MM/YYYY') }} -</template
                    >
                    <template v-if="filter.registerDate.end">{{
                      filter.registerDate.end | DateFormat('DD/MM/YYYY')
                    }}</template>
                  </td>
                </tr>
                <tr class="grey lighten-4">
                  <td>{{ $t('Last Conversation at') }}</td>
                  <td class="primary-color">
                    <div v-if="filter.activeDate.start || filter.activeDate.end">
                      <template v-if="filter.activeDate.start"
                        >{{ filter.activeDate.start | DateFormat('DD/MM/YYYY') }} -</template
                      >
                      <template v-if="filter.activeDate.end">{{
                        filter.activeDate.end | DateFormat('DD/MM/YYYY')
                      }}</template>
                    </div>
                    <div v-else>-</div>
                  </td>
                </tr>
                <tr>
                  <td>{{ $t('Tag') }}</td>
                  <td class="primary-color">{{ filter.tags ? filter.tags : '-' }}</td>
                </tr>
                <tr class="grey lighten-4">
                  <td>{{ $t('Status') }}</td>
                  <td class="primary-color">{{ filter.status ? filter.status : '-' }}</td>
                </tr>
                <template v-if="selectedBot.theme == 'universalutilities'">
                  <tr>
                    <td>{{ $t('ชื่อจริง') }}</td>
                    <td class="primary-color">{{ filter.uu_name ? filter.uu_name : '-' }}</td>
                  </tr>
                  <tr>
                    <td>{{ $t('ประปา') }}</td>
                    <td class="primary-color">
                      {{ filter.uu_areaname ? filter.uu_areaname : '-' }}
                    </td>
                  </tr>
                  <tr>
                    <td>{{ $t('DMA') }}</td>
                    <td class="primary-color">{{ filter.uu_dma ? filter.uu_dma : '-' }}</td>
                  </tr>
                  <tr>
                    <td>{{ $t('Register Status') }}</td>
                    <td class="primary-color">
                      {{ filter.uu_register_status ? filter.uu_register_status : '-' }}
                    </td>
                  </tr>
                </template>
              </table>
            </div>
          </template>
        </div>
      </v-container>
      <v-divider></v-divider>
      <v-container>
        <div>
          {{ $t('Replace a new status for this broadcast') }}
          <v-premium-lock :inline="true"></v-premium-lock>
        </div>
        <div class="mt-1 primary--text">
          {{ update_status ? update_status : '-' }}
        </div>

        <div class="mt-3">
          {{ $t('Add tag for this broadcast') }} <v-premium-lock :inline="true"></v-premium-lock>
        </div>

        <div class="primary--text" v-if="update_tags.length == 0">
          {{ $t('No tag') }}
        </div>
        <template v-else>
          <template v-for="(tag, tindex) in update_tags">
            <v-chip :key="`tags_${tindex}`" class="white--text" disabled small color="primary">
              {{ tag }}
            </v-chip>
          </template>
        </template>
      </v-container>
      <v-divider></v-divider>
      <template v-if="broadcast.isschedule">
        <v-container>
          <div>{{ $t('Schedule Broadcast') }}</div>
          <div class="primary--text">
            {{ broadcast.scheduletime | DateFormat('DD/MM/YYYY hh:mm A') }}
          </div>
        </v-container>
        <v-divider></v-divider>
      </template>
      <v-container>
        <div style="overflow: auto">
          <template v-if="type == 'text'">
            <div>
              <message-viewer v-model="message" style="float: left"></message-viewer>
            </div>

            <div class="clearfix"></div>
          </template>
          <template v-else-if="type == 'template'">
            <generic-viewer v-model="generics" style="float: left"></generic-viewer>
            <div class="clearfix"></div>
          </template>
          <template v-if="type == 'json'">
            <message-viewer v-model="messages" style="float: left"></message-viewer>
          </template>
        </div>
      </v-container>
      <v-divider></v-divider>
      <v-container class="text-xs-center">
        <v-btn outline color="grey" @click="onBack">
          <em class="fas fa-chevron-left mr-1" />
          {{ $t('Back') }}
        </v-btn>
      </v-container>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import config from '@/config'
import GenericViewer from '@/components/elements/GenericViewer'
import MessageViewer from '@/components/elements/MessageViewer'
import api from '@/api'

export default {
  props: ['value'],
  data: function () {
    return {
      broadcast: undefined,
      update_status: '',
      update_tags: [],
      isSave: false,
      isFail: false,
      name: '',
      localeOptions: config.locale,
      type: 'text',
      groupType: '',
      sendtype: 'subscription',
      pushtype: 'regular',
      message: '',
      quick_reply: '',
      typeOptions: [
        {
          value: 'text',
          name: 'Text'
        },
        {
          value: 'template',
          name: 'Generic'
        }
      ],
      generics: [
        {
          image_url: null,
          title: '',
          subtitle: '',
          buttons: [],

          enable: true
        }
      ],
      messages: [],
      filter: {
        fullname: '',
        gender: 'all',
        locale: null,
        app: 'all',
        intent: null,
        email: '',
        phoneno: '',
        messagesent: {
          value: null,
          symbol: ''
        },
        timezone: {
          from: -12,
          to: 14
        },
        activeDate: {
          enable: false,
          start: '',
          end: ''
        },
        registerDate: {
          enable: false,
          start: null,
          end: null
        }
      }
    }
  },
  components: {
    GenericViewer,
    MessageViewer
  },
  mounted: function () {
    var vm = this
    // vm.getIntent(function () {})

    vm.reset()

    if (this.value && this.value.m_condition) {
      let a = this.value.m_condition.split('&')
      let b = {}
      a.forEach((v) => {
        let x = v.split('=')
        b[x[0]] = x[1]
      })
      let c = {
        uu_areaname: b.uu_areaname,
        uu_dma: b.uu_dma,
        uu_name: b.uu_name,
        uu_register_status: b.uu_register_status
      }
      Object.assign(this.filter, c)
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  methods: {
    reset: function () {
      var vm = this
      if (vm.value) {
        vm.broadcast = Object.assign({}, vm.value)
        vm.cached_broadcast = Object.assign({}, vm.value)
      }
      if (vm.broadcast) {
        var filters = vm.broadcast.m_condition.split('&')
        filters = filters.filter((el) => {
          return el != null && el != ''
        })

        if (filters.length > 0) {
          var f = filters.map(function (filter, index) {
            var value = filter.split(/=(.+)/)
            if (value.length > 1) {
              switch (value[0]) {
                case 'fullname':
                case 'gender':
                case 'app':
                case 'email':
                case 'status':
                case 'tags':
                case 'phoneno':
                  vm.filter[value[0]] = value[1]
                  return { id: value[0], value: value[1] }
                  break
                case 'messagesent':
                  var messagesent = value[1].split('__')
                  vm.filter[value[0]] = {
                    value: messagesent[1],
                    symbol: messagesent[0] + '__'
                  }
                  return {
                    id: value[0],
                    value: {
                      value: messagesent[1],
                      symbol: messagesent[0] + '__'
                    }
                  }
                  break
                case 'locale':
                  var locales = value[1].split(',')
                  vm.filter.locale = []
                  vm.filter.locale = vm.localeOptions
                    .map((configLocal, clindex) => {
                      if (locales.includes(configLocal.value)) {
                        return configLocal
                      } else {
                        return null
                      }
                    })
                    .filter((el) => {
                      return el != null
                    })
                  return { id: 'locale', value: vm.filter.locale }
                  break
                case 'intent':
                  vm.filter.intent = value[1].split(',')
                  return { id: 'intent', value: value[1].split(',') }
                  break
                case 'timestamp_from':
                  vm.filter.activeDate.start = moment(value[1]).toDate()
                  return { id: 'activeDate_start', value: moment(value[1]).toDate() }
                  break
                case 'timestamp_to':
                  vm.filter.activeDate.end = moment(value[1]).toDate()
                  return { id: 'activeDate_end', value: moment(value[1]).toDate() }
                  break
                case 'registertimestamp_from':
                  vm.filter.registerDate.start = moment(value[1]).toDate()
                  return { id: 'registerDate_start', value: moment(value[1]).toDate() }
                  break
                case 'registertimestamp_to':
                  vm.filter.registerDate.end = moment(value[1]).toDate()
                  return { id: 'registerDate_end', value: moment(value[1]).toDate() }
                  break
              }
            }
          })

          if (f.length == 1 && (vm.filter['app'] == 'facebook' || vm.filter['app'] == 'line')) {
            vm.groupType = vm.filter['app']
          } else {
            vm.groupType = 'customize'
          }
        }

        vm.name = vm.broadcast.name
        vm.type = 'json'
        vm.quick_reply = vm.broadcast.m_quick_reply
        vm.sendtype = vm.broadcast.sendtype
        vm.pushtype = vm.broadcast.pushtype

        this.update_status = vm.broadcast.update_user_status
        try {
          this.update_tags = vm.broadcast.update_user_tags.split(',')
          this.update_tags = this.update_tags.filter((el) => {
            return el != ''
          })
          // this.tagOptions = this.update_tags
        } catch (error) {}

        if (vm.broadcast.m_type == 'template') {
          vm.messages = [
            [
              {
                type: 'generic',
                data: JSON.parse(vm.broadcast.m_val),
                ratio: vm.broadcast.ratio == 'horizontal' ? 'horizontal' : 'square'
              }
            ]
          ]
        } else if (vm.broadcast.m_type == 'json') {
          vm.messages = JSON.parse(vm.broadcast.m_val)
        } else {
          var newGroup = []
          var group = vm.broadcast.m_val.split('||')
          $.each(group, function (index, messages) {
            var newMessage = []
            var group_messages = messages.split('#nl')
            $.each(group_messages, function (index, message) {
              var type = 'text'
              if (!isNaN(message)) {
                newMessage.push({
                  type: 'text',
                  text: message
                })
              } else if (vm.isJsonParseable(message)) {
                var messageParsed = JSON.parse(message)
                newMessage.push({
                  text: messageParsed.text,
                  buttons: messageParsed.buttons,
                  type: 'button'
                })
              } else if (vm.isURL(message)) {
                newMessage.push({
                  type: 'image',
                  image_url: message
                })
              } else {
                newMessage.push({
                  type: 'text',
                  text: message
                })
              }
            })
            newGroup.push(newMessage)
          })
          vm.messages = newGroup
        }
      } else {
        vm.broadcast = undefined
      }
    },
    onBack: function () {
      var vm = this
      vm.$emit('onClose')
    }
  },
  watch: {
    value: function () {
      this.reset()
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/view/broadcast/BroadcastView.vue